<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { RouteOne } from './Routes/RouteOne';
    import Monetary from '../../shared/Monetary.svelte';

    export let routeOne: RouteOne;
</script>

<div class="route-summary-by-cost-category-container">
    <div class="bold main-title">{$_('Concession fees')}</div>
    <div class="route-summary-values">
        <div>
            <div class="title light">{$_('Cat 1.')}</div>
            <div class="value bold">
                <Monetary value={routeOne.getCalculationResult().getAuCat1()} currency="" />
            </div>
        </div>
        <div>
            <div class="title light">{$_('Cat 2.')}</div>
            <div class="value bold">
                <Monetary value={routeOne.getCalculationResult().getAuCat2()} currency="" />
            </div>
        </div>
        <div>
            <div class="title light">{$_('Cat 3.')}</div>
            <div class="value bold">
                <Monetary value={routeOne.getCalculationResult().getAuCat3()} currency="" />
            </div>
        </div>
        <div>
            <div class="title light">{$_('Cat 4.')}</div>
            <div class="value bold">
                <Monetary value={routeOne.getCalculationResult().getAuCat4()} currency="" />
            </div>
        </div>
    </div>
</div>

<style>
    /*.route-summary-by-cost-category-container {*/
    /*    width: 200px;*/
    /*}*/
    .main-title {
        width: 100%;
        text-align: center;
        padding: 3px 3px;
    }
    .route-summary-values {
        display: flex;
        flex-direction: row;
        column-gap: 10px;
        justify-content: space-around;
        border-top: 1px solid #333;
    }
    .route-summary-values > * {
        padding: 4px 0;
    }
    .route-summary-values .title {
        font-size: 0.8em;
    }
    .route-summary-values .value {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
    }
</style>
